import React, { useState, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NotificationContainer from './components/NotificationContainer';
import ErrorBoundary from './components/ErrorBoundary';
import SkeletonLoader from './components/SkeletonLoader';
import errorHandler from './utils/errorHandler';
import './assets/sass/main.scss';

// Lazy load components for better performance
const PDFViewer = lazy(() => import('./components/PDFViewer'));
const PDFEditToolbar = lazy(() => import('./components/PDFEditToolbar'));
const TextEditModal = lazy(() => import('./components/TextEditModal'));

function App() {
  const [selectedPDF, setSelectedPDF] = useState('/PDF.pdf');

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const url = URL.createObjectURL(file);
      setSelectedPDF(url);
      // Success message will be shown by PDFViewer component
    } else {
      errorHandler.showError('Please select a valid PDF file');
    }
  };

  return (
    <div className="app">
      <ErrorBoundary name="App">
        <Navbar onFileUpload={handleFileUpload} />
        
        <main className="main-content">
          <ErrorBoundary name="PDFViewer">
            <Suspense fallback={<SkeletonLoader variant="pdf-viewer" />}>
              <PDFViewer src={selectedPDF} />
            </Suspense>
          </ErrorBoundary>
        </main>
        
        <Footer />
        <NotificationContainer />
      </ErrorBoundary>
    </div>
  );
}

export default App
